import nestedComponentForm from 'formiojs/components/_classes/nested/NestedComponent.form';
import {
	BaseEditDisplay,
	BaseEditForm,
	IBaseWidgetConfigurationEditFormOptions,
	BaseEditLogic,
	BaseEditApi,
	BaseEditConditional,
	BaseEditLayout
} from '../../configuration-components/base-widget-configuration';
import { CustomComponentType } from '../../../enums';

export default function (...extend: any) {
	return nestedComponentForm(
		[
			new BaseEditDisplay().getTab(),
			new BaseEditForm().getTab({ componentType: CustomComponentType.locationVerification } as IBaseWidgetConfigurationEditFormOptions),
			new BaseEditLogic().getTab({ ignore: true }),
			new BaseEditApi().getTab(),
			new BaseEditConditional().getTab(),
			new BaseEditLayout().getTab({ ignore: true })
		],
		...extend
	);
}
